import * as React from "react";
import Editor from "../editor/Editor";
import { inject } from "mobx-react";
import { observer } from "mobx-react";
import ConnectionLayer from "../editor/ConnectionLayer";
import { Label, StyledDropdown } from "./EditorViewStyles";
import autobind from "autobind-decorator";
import { styled } from "@mui/material/styles";
import { questionTypes, narrativeSplitPoint } from "../editor/NodeLayer";
import {
  Select,
  MenuItem,
  Input,
  Checkbox,
  ListItemText,
  Box,
} from "@mui/material";

type ConnectionLayerPanelViewProps = {
  editor?: Editor;
  className?: string;
  style?: React.CSSProperties;
};

const Para = styled("p")({
  marginTop: "24px",
  color: "rgb(120, 120, 120)",
  fontSize: "12px",
});

@inject("editor")
@observer
export default class ConnectionLayerPanelView extends React.Component<ConnectionLayerPanelViewProps> {
  selectionHasChoices(): boolean {
    var { editor } = this.props;
    if (
      editor.selectedLayer == null ||
      !(editor.selectedLayer instanceof ConnectionLayer)
    ) {
      return false;
    }

    if (
      editor.selectedLayer.startNode.questionType ===
        questionTypes.multiChoice ||
      editor.selectedLayer.startNode.questionType === "Multiple Choice"
    ) {
      return false;
    }

    return editor.selectedLayer.startNode.hasChoices;
  }

  getConditionList(): Array<string> {
    var { editor } = this.props;
    if (
      editor.selectedLayer == null ||
      !(editor.selectedLayer instanceof ConnectionLayer)
    ) {
      return [];
    }

    return editor.selectedLayer.startNode.choices;
  }

  getCondition(): Array<string> {
    var { editor } = this.props;
    if (
      editor.selectedLayer == null ||
      !(editor.selectedLayer instanceof ConnectionLayer)
    ) {
      return [];
    }

    return editor.selectedLayer.condition.split(narrativeSplitPoint);
  }

  hasCondition(condition: string): boolean {
    var conditions = this.getCondition();
    var ret = false;

    conditions.forEach((cond) => {
      if (cond == condition) {
        ret = true;
      }
    });

    return ret;
  }

  @autobind
  handleConditionChanged(ev: any) {
    var { editor } = this.props;
    if (
      editor.selectedLayer == null ||
      !(editor.selectedLayer instanceof ConnectionLayer)
    ) {
      return;
    }
    var array = ev.target.value as string[];

    editor.selectedLayer.setCondition(array.join(narrativeSplitPoint));
  }

  renderChoiceSelector() {
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    var names = this.getConditionList().filter((it) => it != "");

    return (
      <Select
        multiple
        value={this.getCondition()}
        onChange={this.handleConditionChanged}
        input={<Input />}
        renderValue={(selected) =>
          (selected as string[]).filter((val) => val.trim() != "").join(", ")
        }
        MenuProps={MenuProps}
      >
        {names.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={this.hasCondition(name)} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    );
  }

  renderNoChoices() {
    return (
      <>
        {" "}
        <Para>
          You have not set up a conditional path yet inside the question box. To
          do so, you need to select "YES/NO" or "Single Choice" as the Question
          Type in the box. This way, depending on how the user answers your
          question, it will take them down this new path of questions in your
          form, survey, questionnaire, decision tree and workflow.
        </Para>
        <Para>
          To set this up: <br />
          1) Click on the box where arrow was drawn from. <br />
          2) On the right side, go to the Question Type section and choose
          either "YES/NO" or "Single Choice".
          <br /> 3) Create your answer choices
          <br /> 4) Now click on the radio icon in the arrow
          <br /> 5) Panel will appear on the right where you can choose the
          condition or answer choice that will make user get redirected to the
          new question box if they picked that answer choice.
        </Para>
        <Para>
          Conditional paths are great if you want your user to follow a
          different path depending on how they answered a particular question.
          So if they choose YES, they will be directed towards the path you
          created with your arrow. And if they choose NO, you can have them go
          down a different path you created with your arrow.
        </Para>
      </>
    );
  }

  render() {
    return (
      <React.Fragment key="connection-layer-panel">
        <Box px={2}>
          <Label> CONDITIONS </Label>
          {this.selectionHasChoices()
            ? this.renderChoiceSelector()
            : this.renderNoChoices()}
        </Box>
      </React.Fragment>
    );
  }
}
